import { Component, ViewEncapsulation } from '@angular/core';
import { SpaContext } from '../Classes/spacontext';

@Component({
	standalone: false,
	selector: 'mobile-app-promotion',
	template: `
		<div class="contentWrapper" *ngIf="appStoreLink !== null || playStoreLink !== null">
			<div class="textCircle">
				<div class="textHolder">
					<div class="text">
						{{ 'LicenceHolder.MobileAppPromotion.Title' | translate }}
					</div>
				</div>
			</div>
			<a *ngIf="appStoreLink !== null" [href]="appStoreLink">
				<img src="//media-cdn.visibacare.com/service/public/logo/app-store-badge.svg" alt="App store logo" />
			</a>
			<a *ngIf="playStoreLink !== null" [href]="playStoreLink">
				<img src="//media-cdn.visibacare.com/service/public/logo/google-play-badge.png" alt="Google play store logo" />
			</a>
		</div>
	`,
	styleUrls: ['../Css/Components/mobileAppPromotion.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class MobileAppPromotionComponent {
	appStoreLink: string = null;
	playStoreLink: string = null;

	constructor(public _spaContext: SpaContext) {
		if (this._spaContext.unitConfig.AppConfig !== null && this._spaContext.unitConfig.AppConfig.AppStoreId !== null) {
			this.appStoreLink = 'https://itunes.apple.com/se/app/id' + this._spaContext.unitConfig.AppConfig.AppStoreId;
		}

		if (
			this._spaContext.unitConfig.AppConfig !== null &&
			this._spaContext.unitConfig.AppConfig !== null &&
			this._spaContext.unitConfig.AppConfig.AndroidPackageId !== null
		) {
			this.playStoreLink =
				'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=' +
				this._spaContext.unitConfig.AppConfig.AndroidPackageId;
		}
	}
}
